import { Controller } from "@hotwired/stimulus";

// The rebalance form: the three amounts must add up to the current total
// before the form can be sent. The page is reloaded after a successful save.
export default class extends Controller {
  static targets = ["amount", "total", "current", "equal", "group", "submit", "error"];

  connect() {
    this.check();
  }

  numerize({target}) {
    if (this.amountTargets.includes(target)) target.value = parseInt(target.value, 10) || 0;
    this.check();
  }

  check() {
    const total = parseInt(this.totalTarget.value, 10);
    const current = this.amountTargets.reduce((sum, field) => sum + (parseInt(field.value, 10) || 0), 0);
    this.currentTarget.value = current;

    const equal = current === total;
    this.equalTarget.textContent = equal ? "=" : "≠";
    this.groupTarget.classList.toggle("has-success", equal);
    this.groupTarget.classList.toggle("has-error", !equal);
    this.submitTarget.disabled = !equal;
  }

  async submit(event) {
    event.preventDefault();
    this.errorTarget.hidden = true;
    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        body: new FormData(this.element),
        credentials: "same-origin",
        headers: {"X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content},
      });
      if (!response.ok) throw new Error(response.statusText || `HTTP ${response.status}`);
      window.location.reload();
    } catch (error) {
      this.errorTarget.textContent = error.message;
      this.errorTarget.hidden = false;
    }
  }
}
